/* Rquiere de mixin.js */

var productStoreRackSideRowColumn = {
	data () {
		return {
			listProductStoreRackSideRowColumns: [],
			methodsProductStoreRackSideRowColumn: {
			},
			objectProductStoreRackSideRowColumn: {
				exists: 0,
				id: 0,
				product_id: 0,
				store_rack_side_row_column_id: 0,
				status_id: 0,
				quantity: 0,
				created_at: '',
				updated_at: '',
			},
			paginationProductStoreRackSideRowColumns: [],
			searchProductStoreRackSideRowColumns: '',
			savingProductStoreRackSideRowColumn: false
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		clearObjectProductStoreRackSideRowColumn() {
			this.objectProductStoreRackSideRowColumn.exists = 0
			this.objectProductStoreRackSideRowColumn.id = 0
			this.objectProductStoreRackSideRowColumn.product_id = 0
			this.objectProductStoreRackSideRowColumn.store_rack_side_row_column_id = 0
			this.objectProductStoreRackSideRowColumn.status_id = 0
			this.objectProductStoreRackSideRowColumn.quantity = 0
			this.objectProductStoreRackSideRowColumn.created_at = ''
			this.objectProductStoreRackSideRowColumn.updated_at = ''
		},
        deleteItemListProductStoreRackSideRowColumns(id) {
			let index = this.listProductStoreRackSideRowColumns.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			let productStoreRackSideRowColumnDeleted = this.listProductStoreRackSideRowColumns.splice(index,1)
        },
		deleteProductStoreRackSideRowColumn(id) {
			this.savingProductStoreRackSideRowColumn = true
			let url = this.getApiBackend + 'productStoreRackSideRowColumn/' + id + '/delete'
			this.axiosActionIS(url, 'DELETE', 'deleteProductStoreRackSideRowColumnResult')
		},
		deleteProductStoreRackSideRowColumnResult(response) {
			this.savingProductStoreRackSideRowColumn = false
			if(response.data.success == true) {
				this.deleteItemListProductStoreRackSideRowColumns(response.data.data)
			}
			this.deleteProductStoreRackSideRowColumnResultLocal(response)
		},
		deleteProductStoreRackSideRowColumnResultLocal(response) {
			console.log('deleteProductStoreRackSideRowColumnResult no desarrollado', response)
		},
		getProductsForStoreRackSideIds(storeRackSideRowColumnIds) {
			let data = {storeRackSideRowColumnIds: storeRackSideRowColumnIds}
			let url = this.getApiBackend + 'products/storeRackSideRowColumnIds'
			this.axiosActionIS(url, 'POST', 'getProductsForStoreRackSideResult', data)
		},
		getProductsForStoreRackSideResult(response) {
			if(response.data.success == true) {
				this.listProductStoreRackSideRowColumns = response.data.data
			}
			this.getProductsForStoreRackSideResultLocal(response)
		},
		getProductsForStoreRackSideResultLocal(response) {
			console.log('getProductsForStoreRackSideResultLocal no desarrollado', response)
		},
		saveProductStoreRackSideRowColumn(productId, productStoreRackSideRowColumnId) {
			this.savingProductStoreRackSideRowColumn = true
			let data = {
					store_rack_side_row_column_id: productStoreRackSideRowColumnId
				}
			let url = this.getApiBackend + 'product/' + productId + '/storeRackSideRowColumn/register'
			this.axiosActionIS(url, 'POST', 'saveProductStoreRackSideRowColumnResult', data)
		},
		saveProductStoreRackSideRowColumnResult(response) {
			this.savingProductStoreRackSideRowColumn = false
			this.saveProductStoreRackSideRowColumnResultLocal(response)
		},
		saveProductStoreRackSideRowColumnResultLocal(response) {
			console.log('saveProductStoreRackSideRowColumnLocal no desarrollado', response)
		},
		updateProductStoreRackSideRowColumn() {
			this.savingProductStoreRackSideRowColumn = true
			let url = this.getApiBackend + 'productStoreRackSideRowColumn/' + this.objectProductStoreRackSideRowColumn.id + '/update'
			this.axiosActionIS(url, 'PUT', 'updateProductStoreRackSideRowColumnResult', this.objectProductStoreRackSideRowColumn)			
		},
		updateProductStoreRackSideRowColumnResult(response) {
			this.savingProductStoreRackSideRowColumn = false
			this.updateProductStoreRackSideRowColumnResultLocal(response)
		},
		updateProductStoreRackSideRowColumnResultLocal(response) {
			console.log('updateProductStoreRackSideRowColumnResult no desarrollado', response)
		}
	},
};

export default productStoreRackSideRowColumn;